import { useDeviceType } from '@calendly/ui/hooks/use-device-type';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { forwardRef } from 'react';
import { AnimatedFrame } from './animated_frame';
const frameIsBigPhoneUpCss = "fy80tqq";
const frameIsAnimatingCss = "ft8ww9r";
const frameAnimationTargetOutCss = "f1j2s064";
const frameAnimationDirectionRtlCss = "fem5ggq";
const frameAnimationDirectionLtrCss = "f1lfucaw";
const frameAnimationTargetInCss = "f1yc1o3p";
const frameCss = "f12vtz3f";
const Frame = forwardRef((props, ref) => {
  const {
    isAnimating,
    animationTarget,
    animationDirection,
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  const isBigPhoneUp = useDeviceType('isBigPhoneUp');
  return <Component ref={ref} {...restProps} className={classNames(frameCss, {
    [frameIsBigPhoneUpCss]: isBigPhoneUp,
    [frameIsAnimatingCss]: isAnimating,
    [frameAnimationTargetOutCss]: animationTarget?.toString() === 'out',
    [frameAnimationDirectionRtlCss]: animationDirection?.toString() === 'rtl',
    [frameAnimationDirectionLtrCss]: animationDirection?.toString() === 'ltr',
    [frameAnimationTargetInCss]: animationTarget?.toString() === 'in'
  }, props.className)} />;
});
const titleCss = "t1ei4z3f";
export const Title = forwardRef((props, ref) => {
  const {
    as: AsComponent,
    ...restProps
  } = props;
  const Component = AsComponent || 'div';
  return <Component ref={ref} {...restProps} className={classNames(titleCss, props.className)}>
      <AnimatedFrame as={Frame} {...props} />
    </Component>;
});
Title.propTypes = {
  id: PropTypes.number.isRequired,
  children: PropTypes.node.isRequired,
  as: PropTypes.elementType,
  className: PropTypes.string
};

require("./title.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./title.js");